module.exports = __webpack_public_path__ + "img/blurred-qr-code.5d02d45.png";